<!-- <div *ngIf="loaders > 0" class="loader-wrapper w-100 h-100 overflow-hidden position-absolute" style="z-index: 10000; background-color: red;">
  <div class="loader">Loading...</div>
</div> -->

<div *ngIf="loaders > 0" class="loader-wrapper w-100 h-100 overflow-hidden position-absolute" style="z-index: 11;">
    <!----<div class="loader">Loading...</div>--->
</div>

<!---customerlight skeleton--->
<div [@inbgOutAnimation] *ngIf="(currentRoute=='customerlight') && loaders > 0" class="d-block skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:350px; position: absolute; top:80px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:100px; position: absolute; top:450px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:100px; position: absolute; top:570px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:100px; position: absolute; top:690px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:100px; position: absolute; top:810px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:100px; position: absolute; top:930px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:100px; position: absolute; top:1050px; left:1%; z-index: 10;">
    </div>
</div>

<!----portal skeleton lg--->
<div [@inbgOutAnimation] *ngIf="(currentRoute=='portal') && loaders > 0" class="d-none d-md-block skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 80%); height:50px; position: absolute; top:80px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 50%); height:50px; position: absolute; top:80px; left:25%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 85%); height:50px; position: absolute; top:80px; right:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80px; position: absolute; top:150px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80px; position: absolute; top:250px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80px; position: absolute; top:350px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80px; position: absolute; top:450px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80px; position: absolute; top:550px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80px; position: absolute; top:650px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80px; position: absolute; top:750px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80px; position: absolute; top:850px; left:1%; z-index: 10;">
    </div>
</div>
<!----portal skeleton sm---->
<div [@inbgOutAnimation] *ngIf="(currentRoute=='portal') && loaders > 0" class="d-block d-md-none skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 60%); height:50px; position: absolute; top:80px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 60%); height:50px; position: absolute; top:80px; right:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80px; position: absolute; top:150px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80px; position: absolute; top:250px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80px; position: absolute; top:350px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80px; position: absolute; top:450px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80px; position: absolute; top:550px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80px; position: absolute; top:650px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80px; position: absolute; top:750px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80px; position: absolute; top:850px; left:3%; z-index: 10;">
    </div>
</div>
<!----portal work skeleton lg---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='portal/project' && loaders > 0"
    class="d-none d-md-block skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:50px; position: absolute; top:80px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 70%); height:500px; position: absolute; top:150px; right:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 70%); height:500px; position: absolute; top:150px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 70%); height:500px; position: absolute; top:150px; right:35%; z-index: 10;">
    </div>
</div>
<!----portal work skeleton sm---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='portal/project' && loaders > 0"
    class="d-block d-md-none skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:50px; position: absolute; top:80px; left:1%;  z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 70%); height:500px; position: absolute; top:150px; right:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 70%); height:500px; position: absolute; top:150px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 70%); height:500px; position: absolute; top:150px; right:35%; z-index: 10;">
    </div>
</div>
<!----people skeleton lg---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='people' && loaders > 0" class="d-none d-md-block skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 80%); height:40px; position: absolute; top:80px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:60px; position: absolute; top:135px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 75%); height:40px; position: absolute; top:210px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 96%); height:40px; position: absolute; top:210px; right:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:600px; position: absolute; top:270px; left:1%; z-index: 10;">
    </div>
</div>
<!----people skeleton sm--->
<div [@inbgOutAnimation] *ngIf="currentRoute=='people' && loaders > 0" class="d-block d-md-none skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 50%); height:40px; position: absolute; top:80px;  z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:60px; position: absolute; top:135px; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 50%); height:40px; position: absolute; top:210px; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:600px; position: absolute; top:270px; z-index: 10;">
    </div>
</div>
<!----planning skeleton lg---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='planning' && loaders > 0" class="d-none d-md-block skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:40px; position: absolute; top:80px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:80%; position: absolute; top:135px; left:1%; z-index: 10;">
    </div>
</div>
<!----planning skeleton sm---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='/planning' && loaders > 0" class="d-block d-md-none skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:40px; position: absolute; top:80px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:80%; position: absolute; top:135px; left:3%; z-index: 10;">
    </div>
</div>
<!----customer skeleton lg---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='customers' && loaders > 0" class="d-none d-md-block skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 80%); height:50px; position: absolute; top:80px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 90%); height:40px; position: absolute; top:90px; right:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:600px; position: absolute; top:150px; left:1%; z-index: 10;">
    </div>
</div>
<!----customer skeleton sm---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='customers' && loaders > 0" class="d-block d-md-none skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 60%); height:50px; position: absolute; top:80px; left:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 70%); height:40px; position: absolute; top:90px; right:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:600px; position: absolute; top:150px; left:3%; z-index: 10;">
    </div>
</div>
<!----customer page skeleton lg---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='customer' && loaders > 0" class="d-none d-md-block skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:285px; position: absolute; top:80px; left:1%;   z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:10%; position: absolute; top:380px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 2%); height:25%; position: absolute; top:500px; left:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 53%); height:15%; position: absolute; top:765px; right:1%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 53%); height:15%; position: absolute; top:765px; left:1%; z-index: 10;">
    </div>
</div>
<!----customer page skeleton sm---->
<div [@inbgOutAnimation] *ngIf="currentRoute=='customer' && loaders > 0" class="d-block d-md-none skeleton-wrapper">
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:285px; position: absolute; top:80px; right:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:10%; position: absolute; top:380px; right:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 6%); height:25%; position: absolute; top:500px; right:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 55%); height:15%; position: absolute; top:765px; right:3%; z-index: 10;">
    </div>
    <div class="loader"
        style="background-color: #ccc; width:calc(100% - 55%); height:15%; position: absolute; top:765px; left:3%; z-index: 10;">
    </div>
</div>